module.exports = __webpack_public_path__ + "img/boiling.960520b8.jpg";